import { Component, Input, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-user-contact-information',
    templateUrl: './user-contact-information.component.html',
    styleUrls: ['./user-contact-information.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class UserContactInformationComponent {
    @Input() content: any;
    @Input() profileForm: FormGroup;

    trackByIndex = (index: number): number => index;

    constructor() {}
}
